/**
 * @generated SignedSource<<b8455fb7b841eb60a931deb14bb935ab>>
 * @relayHash 2efdea558d49f1b0dbee45f7e5adc6bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98ab0ac6008fecd020ee4a7884fe785e2c6e39df68093c3845273b0583a04faa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { hubHomeContentWrapperQuery } from './hubHomeContentWrapperQuery.graphql';

const node: PreloadableConcreteRequest<hubHomeContentWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "98ab0ac6008fecd020ee4a7884fe785e2c6e39df68093c3845273b0583a04faa",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
